/**
 * Utilidades para verificar permisos del usuario
 */

/**
 * Verifica si el usuario tiene un permiso específico
 * @param {Object} store - Instancia del store de Vuex
 * @param {string} permission - Nombre del permiso a verificar
 * @returns {boolean}
 */
export const hasPermission = (store, permission) => {
  if (!store || !permission) return false;
  return store.getters.hasPermission(permission);
};

/**
 * Verifica si el usuario puede eliminar en un módulo
 * @param {Object} store - Instancia del store de Vuex
 * @param {string} module - Nombre del módulo
 * @returns {boolean}
 */
export const canDelete = (store, module) => {
  if (!store || !module) return false;
  return store.getters.canDelete(module);
};

/**
 * Verifica si el usuario tiene un rol específico
 * @param {Object} store - Instancia del store de Vuex
 * @param {string} role - Nombre del rol
 * @returns {boolean}
 */
export const isRole = (store, role) => {
  if (!store || !role) return false;
  return store.getters.isRole(role);
};

/**
 * Verifica si el usuario es Administrador
 * @param {Object} store - Instancia del store de Vuex
 * @returns {boolean}
 */
export const isAdmin = (store) => {
  if (!store) return false;
  return store.getters.isAdmin;
};

/**
 * Verifica si el usuario es Supervisor
 * @param {Object} store - Instancia del store de Vuex
 * @returns {boolean}
 */
export const isSupervisor = (store) => {
  if (!store) return false;
  return store.getters.isSupervisor;
};

/**
 * Verifica si el usuario es Agente
 * @param {Object} store - Instancia del store de Vuex
 * @returns {boolean}
 */
export const isAgente = (store) => {
  if (!store) return false;
  return store.getters.isAgente;
};

/**
 * Constantes de permisos para facilitar su uso
 */
export const Permissions = {
  // Seguridad
  SECURITY_USER_CRUD: 'security.user.crud',
  SECURITY_USER_DELETE: 'security.user.delete',
  SECURITY_ROLE_CRUD: 'security.role.crud',
  SECURITY_ROLE_DELETE: 'security.role.delete',
  SECURITY_PERMISSION_CRUD: 'security.permission.crud',
  SECURITY_PERMISSION_DELETE: 'security.permission.delete',
  SECURITY_TRACES_VIEW: 'security.traces.view',
  
  // Vehículos
  VEHICLES_CRUD: 'vehicles.crud',
  VEHICLES_DELETE: 'vehicles.delete',
  VEHICLES_SALES_CRUD: 'vehicles.sales.crud',
  VEHICLES_SALES_DELETE: 'vehicles.sales.delete',
  VEHICLES_RECOVERED_VIEW: 'vehicles.recovered.view',
  VEHICLES_RECOVERED_SELL: 'vehicles.recovered.sell',
  
  // Gestión - Clientes
  CLIENTS_CRUD: 'clients.crud',
  CLIENTS_DELETE: 'clients.delete',
  CLIENTS_DOCUMENTS_DELETE: 'clients.documents.delete',
  
  // Gestión - Contratos
  CONTRACTS_VIEW: 'contracts.view',
  CONTRACTS_EDIT: 'contracts.edit',
  CONTRACTS_PDF: 'contracts.pdf',
  CONTRACTS_UPLOAD: 'contracts.upload',
  CONTRACTS_CANCEL: 'contracts.cancel',
  CONTRACTS_CANCEL_APPROVAL: 'contracts.cancel.approval',
  
  // Gestión - WhatsApp
  WHATSAPP_CRUD: 'whatsapp.crud',
  WHATSAPP_DELETE: 'whatsapp.delete',
  
  // Gestión - Sucursales
  BRANCHES_CRUD: 'branches.crud',
  BRANCHES_DELETE: 'branches.delete',
  
  // Pagos
  PAYMENTS_CALENDAR_VIEW: 'payments.calendar.view',
  PAYMENTS_CREATE: 'payments.create',
  PAYMENTS_LIST_VIEW: 'payments.list.view',
  
  // Citas de Cobranza
  APPOINTMENTS_CRUD: 'appointments.crud',
  APPOINTMENTS_REASSIGN: 'appointments.reassign',
  
  // Cotizaciones
  QUOTES_VIEW: 'quotes.view',
  QUOTES_EDIT: 'quotes.edit',
  QUOTES_PDF: 'quotes.pdf',
  QUOTES_CANCEL: 'quotes.cancel',
  QUOTES_CANCELED_VIEW: 'quotes.canceled.view',
  QUOTES_MODIFY_AMOUNT: 'quotes.modify.amount',
  QUOTES_MODIFY_AMOUNT_APPROVAL: 'quotes.modify.amount.approval',
  
  // Nomencladores
  CATALOGS_CRUD: 'catalogs.crud',
  CATALOGS_DELETE: 'catalogs.delete',
  
  // Reportes
  REPORTS_VIEW: 'reports.view',
  
  // Configuración del Sistema
  SYSTEM_SETTINGS: 'system.settings',
  
  // Permisos de acceso a módulos (para controlar visibilidad en el menú)
  MODULE_SECURITY_ACCESS: 'module.security.access',
  MODULE_VEHICLES_ACCESS: 'module.vehicles.access',
  MODULE_MANAGEMENT_ACCESS: 'module.management.access',
  MODULE_QUOTES_ACCESS: 'module.quotes.access',
  MODULE_CATALOGS_ACCESS: 'module.catalogs.access',
  MODULE_REPORTS_ACCESS: 'module.reports.access',
};

/**
 * Constantes de roles
 */
export const Roles = {
  ADMINISTRADOR: 'Administrador',
  SUPERVISOR: 'Supervisor',
  AGENTE: 'Agente',
};

